export const scrollToItem = (id: string) => {
  const element = document.getElementById(id);
  element?.scrollIntoView({
    behavior: "smooth",
    block: "center",
  });
};

export const scrollToTop = (id: string) => {
  const element = document.getElementById(id);
  element?.scrollTo({ top: 0, behavior: "smooth" });
};
